/* ==========================================================================
   SearcherFli > Client > Submit > Constants
   ========================================================================== */

const LOB = 'LineOfBusiness';
const PRODUCT_TYPE = 'ProductType';
const CABIN_CLASS = 'CabinClass';
const FAMILY_DISCOUNT = 'FamilyDiscount';
const ORIGIN_AIRPORT_CODE = 'OriginAirportCode';
const DESTINATION_AIRPORT_CODE = 'DestinationCode';
const DEPARTURE_DATE_STR = 'DepartureDateStr';
const RETURN_DATE_STR = 'ReturnDateStr';
const HASH_ROOMS = 'hashRooms';
const ITINERARY_HASH = 'ItineraryHash';
const AIR = 'AIR';
const ADULTS = '30A';
const CHILDREN = '08C';
const BABIES = '00C';
const COMPANY = 'Company';
const AERIAL_COMPANY_NAME = 'AerialCompanyName';
const DIRECT = 'Direct';
const TOUR_OPERATOR = 'TourOperator';
const REFUNDABLE = 'Refundable';
const ETHNIC = 'Ethnic';

/* Exports */
module.exports = {
    LOB,
    PRODUCT_TYPE,
    CABIN_CLASS,
    FAMILY_DISCOUNT,
    ORIGIN_AIRPORT_CODE,
    DESTINATION_AIRPORT_CODE,
    DEPARTURE_DATE_STR,
    RETURN_DATE_STR,
    HASH_ROOMS,
    ITINERARY_HASH,
    AIR,
    ADULTS,
    CHILDREN,
    BABIES,
    COMPANY,
    AERIAL_COMPANY_NAME,
    DIRECT,
    TOUR_OPERATOR,
    REFUNDABLE,
    ETHNIC
};
